module.exports = __webpack_public_path__ + "static/media/coins-silver.ead45b2e.png";